// components/canvas/ZoomToggle.jsx
import React from 'react';
import ShareButton from './ShareButton'; // adjust path if necessary

const ZoomToggle = ({
  isZoomInDisabled,
  isZoomOutDisabled,
  startZoomIn,
  startZoomOut,
  stopZoom,
  zoom,
  step,
  layerSettings,
  formattedDate,
  personalSettings,
  isSquare,
  otherSettings,
  frameSettings,
  exportSVGString,
}) => {
  return (
    <div
      className="zoom-toggle"
      style={{
        justifyContent: step === 5 ? 'space-between' : 'flex-end',
      }}
    >
      {/* Show ShareButton only on step === 5 */}
      {step === 5 && (
        <div style={{ display: 'flex', justifyContent: 'center' }} className='share-btn'>
          <ShareButton
            layerSettings={layerSettings}
            formattedDate={formattedDate}
            personalSettings={personalSettings}
            isSquare={isSquare}
            otherSettings={otherSettings}
            frameSettings={frameSettings}
            exportSVGString={exportSVGString}
          />
        </div>
      )}
      <div className="zoom-indicators">
      <div className={`zoom-indicator-plus ${isZoomInDisabled ? 'disabled' : ''}`}
        onMouseDown={startZoomIn}
        onMouseUp={stopZoom}
        onMouseLeave={stopZoom}
        onTouchStart={startZoomIn}
        onTouchEnd={stopZoom}>+</div>
      <div className={`zoom-indicator-minus ${isZoomOutDisabled ? 'disabled' : ''}`}
        onMouseDown={startZoomOut}
        onMouseUp={stopZoom}
        onMouseLeave={stopZoom}
        onTouchStart={startZoomOut}
        onTouchEnd={stopZoom}
      >-</div>
      </div>
    </div>
  );
};

export default ZoomToggle;
